import React from 'react';
import { formatNumber } from '../utils/helper';
import { Link } from 'react-router-dom';

const worldColumns = [
  {
    title: 'Country',
    field: 'country',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => (
      <div className="country--wrapper">
        <div className="country--name">
          <Link to={`/details/${rowData.countryInfo.iso2}`}>
            <span>{rowData.country}</span>
          </Link>
          <div className="country--flag">
            <img src={`https://www.countryflags.io/${rowData.countryInfo.iso2}/flat/64.png`} alt="flag" style={{ width: 30 }} />
          </div>
        </div>
      </div>
    )
  },
  {
    title: 'Cases',
    field: 'cases',
    width: 300,
    defaultSort: 'desc',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      let increment = (rowData.todayCases > 0) ? <span className="column--increment">+ {rowData.todayCases}</span> : null;
      return (
        <div className="column--wrapper--totalcases">
          <span>{formatNumber(rowData.cases)}</span>
          {increment}
        </div>
      );
    }
  },
  {
    title: 'Cases / 1M',
    field: 'casesPerOneMillion',
    width: 180,
    defaultSort: 'desc',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalcases">
          <span>{formatNumber(rowData.casesPerOneMillion)}</span>
        </div>
      );
    }
  },
  {
    title: 'Deaths',
    field: 'deaths',
    width: 220,
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      let increment = (rowData.todayDeaths > 0) ? <span className="column--increment">+ {rowData.todayDeaths}</span> : null;
      return (
        <div className="column--wrapper--totaldeaths">
          <span>{formatNumber(rowData.deaths)}</span>

          {increment}
        </div>
      );
    }
  },
  {
    title: 'Deaths / 1M',
    field: 'deaths',
    width: 180,
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totaldeaths">
          <span>{formatNumber(rowData.deathsPerOneMillion)}</span>
        </div>
      );
    }
  },
  {
    title: 'Recovered',
    field: 'recovered',
    // width: 100,
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      let increment = (rowData.todayRecovered > 0) ? <span className="column--increment">+ {rowData.todayRecovered}</span> : null;
      return (
        <div className="column--wrapper--totalrecovered">
          <span>{formatNumber(rowData.recovered)}</span>

          {increment}
        </div>
      );
    }
  },
  {
    title: 'Active',
    field: 'active',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.active)}</div>
      );
    }
  },
  {
    title: 'Tests',
    field: 'tests',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.tests)}</div>
      );
    }
  },
  {
    title: 'Tests / 1M',
    field: 'testsPerOneMillion',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.testsPerOneMillion)}</div>
      );
    }
  }
];

const col = {
  title: 'States',
  field: 'state',
  headerStyle: {
    backgroundColor: '#ffffff',
    color: '#000000',
    fontWeight: 'bold',
    fontSize: '18px',
    textAlign: 'center',
  },
  cellStyle: {
    textAlign: 'center',
    borderRight: '1px solid #000',
  },
  render: rowData => (
    <div className="country--wrapper">
      <div className="country--name">
        <span>{rowData.state}</span>
      </div>
    </div>
  )
};

const standCol = {
  title: 'Region',
  field: 'displayName',
  headerStyle: {
    backgroundColor: '#ffffff',
    color: '#000000',
    fontWeight: 'bold',
    fontSize: '18px',
    textAlign: 'center',
  },
  cellStyle: {
    textAlign: 'center',
    borderRight: '1px solid #000',
  },
  render: rowData => (
    <div className="country--wrapper">
      <div className="country--name">
        <span className="nounderline">{rowData.displayName}</span>
      </div>
    </div>
  )
};

const otherCols = [
  {
    title: 'Cases',
    field: 'cases',
    // width: 100,
    defaultSort: 'desc',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      let increment = (rowData.todayCases > 0) ? <span className="column--increment">+ {rowData.todayCases}</span> : null;
      return (
        <div className="column--wrapper--totalcases">
          <span>{formatNumber(rowData.cases)}</span>

          {increment}
        </div>
      );
    }
  },
  {
    title: 'Deaths',
    field: 'deaths',
    // width: 100,
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      let increment = (rowData.todayDeaths > 0) ? <span className="column--increment">+ {rowData.todayDeaths}</span> : null;
      return (
        <div className="column--wrapper--totaldeaths">
          <span>{formatNumber(rowData.deaths)}</span>

          {increment}
        </div>
      );
    }
  },
  {
    title: 'Recovered',
    // width: 100,
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalrecovered">
          <span>{formatNumber(rowData.cases - rowData.active - rowData.deaths)}</span>
        </div>
      );
    }
  },
  {
    title: 'Active',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.active)}</div>
      );
    }
  },
  {
    title: 'Tests',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.tests)}</div>
      );
    }
  },
  {
    title: 'Tests / 1M',
    headerStyle: {
      backgroundColor: '#ffffff',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: '18px',
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
      borderRight: '1px solid #000',
    },
    render: rowData => {
      return (
        <div className="column--wrapper--totalactive">{formatNumber(rowData.testsPerOneMillion)}</div>
      );
    }
  }
];

const usaColumns = [
  col,
  ...otherCols
];

const stateCol = [
  standCol,
  ...otherCols
];

export {
  usaColumns,
  worldColumns,
  stateCol
};